import { Nullable } from '@dxb-web-ui-framework/common/types';
import { PartyIdentification } from '../../../../card/src/types';
import { CardHeaders } from '../../../../userProfile/src/domain/UserInfo/entities';
import { PartyRelationship } from '../../../../userProfile/src/domain/UserInfo/entities/PostLoginCardResponseDTO';
import { TransactionType } from '../../domain/Transaction/entities/TransactionType';
import { TransactionStatus } from '../../domain/Transaction/entities/TransactionStatus';
import { OrderStatus } from '../../domain/Transaction/entities/OrderStatus';

export type ParametersState = {
  transactionStatusesData?: Nullable<TransactionStatus[]>;
  transactionTypesData?: Nullable<TransactionType[]>;
  orderStatusesData?: Nullable<OrderStatus[]>;
  postLoginCardData?: Nullable<{
    cardHeaders: CardHeaders;
    selectedPartyIdentification?: PartyIdentification;
    partyRelationships?: PartyRelationship[];
    partyRoles?: PartyRole[];
  }>;
};

export enum PartyRole {
  BASIC = 'Basic',
  INITIATOR = 'Initiator',
  AUTHORIZER = 'Authorizer',
  FULL_ACCESS = 'FullAccess',
  PAYROLL_USER = 'PayrollUser',
  CARD_HOLDER = 'CardHolder',
  INDIVIDUAL = 'Individual',
  CARD_ADMIN = 'CardAdmin',
}
